export default import.meta.ROLLDOWN_FILE_URL_ReQ3$2gG84Su$nlCVf63EA